import React from "react";
import { Link } from "react-router-dom";


function HomePage() {
  

  return (
      <>
      {/* ============================================================
        HOMEPAGE INTRO / SEO SECTION
        ============================================================ */}
    <section className="home-hero">
      <h1>Free Aviation Preflight Calculators for Pilots</h1>

      <p>
        Free aviation preflight calculators for density altitude, 
        pressure altitude, wind correction angle,
        crosswind components, compass turns, and aircraft weight and balance.
      </p>
      <p>
          Use these tools to support preflight planning, training, and aeronautical
          decision-making before every flight.
        </p>
    </section>
      {/* ============================================================
                Tool Cards Section
                ============================================================ */}
          <h2>Choose a Preflight Calculator</h2>

          <section className="tool-cards">
            <div className="tool-card">
              <Link to="/density-altitude">Density Altitude Calculator</Link>
            </div>

            <div className="tool-card">
              <Link to="/cw">Crosswind</Link>
            </div>

            <div className="tool-card">
              <Link to="/winds">Winds Aloft & WCA</Link>
            </div>

            <div className="tool-card">
              <Link to="/wtbals">Weight & Balance</Link>
            </div>
          </section>



        {/* ============================================================
                OPTIONAL AD PLACEMENT
                ============================================================ */}
            <div className="ad-banner">
              Ad Space
            </div>


        
      
            
    

    {/* ============================================================
      SEO TEXT SECTION
      ============================================================ */}
    <section className="home-info-section">
      <h2>Preflight Planning Tools for General Aviation </h2>

      <p className="purpose-info-text">
        Preflight planning is required under 14 CFR § 91.103, which requires
        each pilot in command, before beginning a flight, to become familiar
        with all available information concerning that flight.
        <br></br>
        This application is designed to support common preflight calculations,
        including density altitude, wind correction, compass-turn planning,
        and weight and balance review.

        <br></br>
        - Density altitude affects takeoff distance, landing distance and climb
        performance. 
        <br></br>
        - Wind correction helps estimate headings, groundspeed
         and fuel planning for each leg of a flight. 
        <br></br>
        - Compass-turn calculations help pilots understand magnetic compass behavior.
        <br></br>
        - Weight and balance calculations help evaluate aircraft loading and center of gravity.
       
      </p>
    </section>
  </>
  );
}


      

export default HomePage;